module.exports = __webpack_public_path__ + "images/a914ebff0113d6501a3fd1a06625975b.svg";